import content from "../data/content.json";
import site from "../data/site.json";
import { multipropriedadeConfig } from "../config/niches/multipropriedade";
import { saldoRetidoConfig } from "../config/niches/saldoRetido";
import { buildAboutJsonLd, buildHomeJsonLd } from "./seo";

export const aboutJsonLd = buildAboutJsonLd(site.company, content.about.title);

const PRICES: Record<string, number> = { "saldo-retido": saldoRetidoConfig.price, multipropriedade: multipropriedadeConfig.price };

export const homeJsonLd = buildHomeJsonLd(
  site.company,
  content.home.offers.map((o) => ({ name: o.name, url: `/${o.niche}`, price: PRICES[o.niche] })),
);
